import React from "react";

import { Grid, Text, AvatarIcon } from "atoms";
import MemoChevronDownSharp from "assets/icons/ChevronDownSharp";

export const ProfileAvatar = ({ name }) => {
  return (
    <>
      <Grid gridAutoFlow="column" justifyContent="start" alignItems="center">
        <AvatarIcon name={name} />
        <Text
          fontSize="1.8rem"
          color="neutral.500"
          fontFamily="NeometricBold"
          pl="1.5rem"
          mr="1rem"
        >
          Hi {name !== null ? name : "Guest"}
        </Text>
        <MemoChevronDownSharp width="1.27rem" height="1rem" />
      </Grid>
    </>
  );
};
